module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_6005.63ced7fe.png";